import { Component, Input, OnInit } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { Session, SessionClaims, SessionsService } from '../../services/sessions.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { MenuItem } from 'primeng/api';

/**
 * Component for displaying and managing active sessions.
 *
 * This component allows users to view their active sessions, switch between them, and sign out.
 */
@Component({
  selector: 'app-besharp-active-session-badge',
  imports: [SelectModule, FormsModule, ReactiveFormsModule, ButtonModule, DividerModule, MenuModule, AvatarModule],
  templateUrl: './active-session-badge.component.html',
  styleUrls: ['./active-session-badge.component.scss'], // corrected styleUrl to styleUrls
})
export class DropdownSessionSelectorComponent implements OnInit {
  /**
   * The key of the session claim to display as the label.
   *
   * Defaults to 'username'.
   */
  @Input() labelKey: keyof SessionClaims = 'username';

  /**
   * List of available sessions.
   */
  protected sessions: Session[];

  /**
   * The currently active session, or null if no session is active.
   */
  protected activeSession: Session | null;

  /**
   * Flag indicating whether the component is currently loading.
   */
  protected loading: boolean = false;

  /**
   * List of actions available for the active session.
   */
  protected activeSessionActions: MenuItem[] = [
    {
      label: 'Switch Session',
      icon: 'pi pi-users',
      command: () => this.router.navigate(['session', 'select']),
    },
    {
      label: 'Sign out',
      icon: 'pi pi-sign-out',
      command: () => {
        if (this.activeSession) {
          this.sessionsService.removeSession(this.activeSession?.id);
        }
      },
    },
  ];

  /**
   * Constructs a new instance of the component.
   *
   * @param sessionsService Service for managing sessions.
   * @param router Router for navigating to other routes.
   */
  public constructor(
    protected sessionsService: SessionsService,
    protected router: Router
  ) {
    this.sessions = sessionsService.getSessions();
    this.activeSession = null;
  }

  /**
   * Initializes the component.
   *
   * Retrieves the active session and sets the loading flag.
   */
  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.activeSession = await this.sessionsService.getActiveSession().finally(() => (this.loading = false));
  }
}
